import styled from "styled-components";

const Box = styled.div`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  position: absolute;
  top: ${({ top }) => top}px;
  left: ${({ left }) => left}px;
  padding-top: ${({ paddingTop }) => paddingTop}px;
  padding-bottom: ${({ paddingTop }) => paddingTop}px;
  padding-left: ${({ paddingLeft }) => paddingLeft}px;
  padding-right: ${({ paddingLeft }) => paddingLeft}px;
  background-color: rgba(162, 219, 255, 0.13);
  border-radius: 35px;
  margin-top: ${({ marginTop }) => marginTop}px;
`;

const Pin = styled.img`
  width: 28px;
  height: 28px;
  margin-right: 7px;
`;

const Title = styled.span`
  font-size: ${({ titleFontSize }) => titleFontSize}px;
  font-weight: 600;
  color: #292929;
  margin-top: 6px;
`;

const Des = styled.div`
  width: ${({ DesWidth }) => DesWidth}px;
  font-size: ${({ desFontSize }) => desFontSize}px;
  line-height: ${({ lineHeight }) => lineHeight}px;
  color: #292929;
`;

const Card = ({
  width,
  height,
  top,
  left,
  title,
  des,
  titleFontSize,
  desFontSize,
  marginTop,
  paddingLeft,
  paddingTop,
  DesWidth,
  marginBottom,
  lineHeight,
}) => {
  return (
    <Box
      width={width}
      height={height}
      marginTop={marginTop}
      top={top}
      left={left}
      paddingTop={paddingTop}
      paddingLeft={paddingLeft}
      DesWidth={DesWidth}
    >
      <div
        style={{
          marginBottom: marginBottom,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Pin src="/img/pin.png" />
        <Title titleFontSize={titleFontSize}>{title}</Title>
      </div>
      <Des desFontSize={desFontSize} lineHeight={lineHeight}>
        {des}
      </Des>
    </Box>
  );
};

export default Card;
